export const LINK_EXPIRED_PATH = '/signup/link_expired';
